import React from "react";

const Cup = ({ isYellow = false }) => {
  const rootClassName = isYellow ? "cup cup--map" : "cup";

  return (
    <div className={rootClassName}>
      <div className="column-flag">
        <div className="cup-column-0"></div>
        <div className="cup-column-0bis"></div>
        <div className="cup-column-1"></div>
        <div className="cup-column-2"></div>
      </div>

      <div className="column-flag">
        <div className="cup-column-3"></div>
        <div className="cup-column-4"></div>
        <div className="cup-column-5"></div>
        <div className="cup-column-6"></div>
      </div>

      <div className="column-flag">
        <div className="cup-column-7"></div>
        <div className="cup-column-8"></div>
        <div className="cup-column-9"></div>
        <div className="cup-column-10"></div>
      </div>

      <div className="column-flag">
        <div className="cup-column-11"></div>
        <div className="cup-column-12"></div>
        <div className="cup-column-13"></div>
        <div className="cup-column-14"></div>
      </div>

      <div className="column-flag">
        <div className="cup-column-14"></div>
        <div className="cup-column-13"></div>
        <div className="cup-column-12"></div>
        <div className="cup-column-11"></div>
      </div>

      <div className="column-flag">
        <div className="cup-column-10"></div>
        <div className="cup-column-9"></div>
        <div className="cup-column-8"></div>
        <div className="cup-column-7"></div>
      </div>

      <div className="column-flag">
        <div className="cup-column-6"></div>
        <div className="cup-column-5"></div>
        <div className="cup-column-4"></div>
        <div className="cup-column-3"></div>
      </div>

      <div className="column-flag">
        <div className="cup-column-2"></div>
        <div className="cup-column-1"></div>
        <div className="cup-column-0bis"></div>
        <div className="cup-column-0"></div>
      </div>
    </div>
  );
};

export default Cup;
